import React from "react";

export default function ResetTableButton(props){
    return(
        <a href="#" onClick={props.onResetTableButtonClick}>Reset</a>
    )
}
